<template>
  <div class="container">
        <form @keydown="clearInput($event.target.name)">
          <div class="row">
          <div class="col-md-6">
            <form-input :label="Lang.get('messages.name')" name="name" :model="request"
                        :errors="formErrors"  />
          </div>
          <div class="col-md-6">
            <form-input :label="Lang.get('messages.email')" name="email" :model="request"
                        :errors="formErrors"  type="email"/>
          </div>
            <div class="col-md-6">
              <form-input :label="Lang.get('messages.phone')" name="phone" :model="request"
                          :errors="formErrors" type="tel"  />
            </div>
            <div class="col-md-6">
              <form-input :label="Lang.get('messages.password')" name="password" :model="request"
                          :errors="formErrors" type="password"  />
            </div>


            <div class="col-12">
            <div class="form-group">
            <button type="submit"    class="custom-btn confirm-btn" @click.prevent="submit" :disabled="submitted">
                {{Lang.get('messages.save')}}
            </button>
            </div>
          </div>
          </div>
        </form>
  </div>
</template>

<script>
    import Requests from "@api/user.api";
    import StorageService from '@services/storage.service';


    export default {
        props: {
            request : {
                type: [Object, Array],
                required: true
            }
        },

        data() {
            return {

            };
        },
        watch: {
            request() {
                this.clearErrors();

            }
        },
        methods: {
            submit() {
                this.$Progress.start();
                this.submitted = true;
                return this.save();
            },

            // update
            save() {
                Requests.updateProfile(this.request).then(res => {
                  let data = res.data.data;
                  let updatedUser= data.user


                 StorageService.saveItem('user', updatedUser, true);

                  this.$store.commit("users/set_user", updatedUser)
                      this.$Progress.finish();
                     this.submitted = false;
                   this.$emit("updated", res.data);

                    })
                    .catch(error => {
                  this.formErrors = error.response.data.errors;
                  this.submitted = false;
                });

            },

        },
    };
</script>
<style>
</style>
